module.exports = __webpack_public_path__ + "static/img/body2.a45ba1c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body2.jpeg
// module id = FPC/
// module chunks = 1